import React, { ChangeEvent, FC } from "react";

interface Props {
  name: string;
  label: string;
  value: string;
  selected: string;
  inputAttrs?: any;
  onChange: (value: string) => void;
  errorMessage?: string;
}

export const FormRadio: FC<Props> = ({
  name,
  label,
  value,
  selected,
  inputAttrs,
  onChange,
  errorMessage,
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div>
      <label className="formRadio">
        <input
          type="radio"
          name={name}
          {...inputAttrs}
          checked={value === selected}
          onChange={handleChange}
          className="sr-only"
          value={value}
        />
        <div
          className={`formRadio--circle ${value === selected ? "checked" : ""}`}
        >
          <div className="formRadio--circle-check" />
        </div>
        <span className="formRadio--label">{label}</span>
      </label>
      {errorMessage && <span className="formRadio--error">{errorMessage}</span>}
    </div>
  );
};
